import isNil from "lodash/isNil";

import { SkipLogicCondition, SkipLogicPredefinedControl, SkipLogicPredefinedControlType } from "./skip-logic.types";

type GetProcessedControlsParams = {
  onConditionMove: (direction: "up" | "down") => void;
  onOpenFoldersSelector: () => void;
  selectedConditionId?: SkipLogicCondition["id"];
  conditions: SkipLogicCondition[];
  onAllConditionsRemove: () => void;
  controls: Array<SkipLogicPredefinedControl>;
};

export type SkipLogicInternalControl = {
  type?: SkipLogicPredefinedControlType;
  handler?: () => void;
  iconSrc?: string;
  description?: string;
  disabled?: boolean
};

export const getProcessedControls = ({
  onConditionMove,
  onAllConditionsRemove,
  conditions,
  selectedConditionId,
  onOpenFoldersSelector,
  controls,
}: GetProcessedControlsParams): Array<SkipLogicInternalControl> => {
  const predefinedActionsConfig: Record<SkipLogicPredefinedControlType, { config: SkipLogicInternalControl }> = {
    [SkipLogicPredefinedControlType.moveUp]: {
      config: {
        handler: () => onConditionMove("up"),
        iconSrc: "png/arrow_up.png",
        description: "move-up-condition",
        disabled: conditions.length < 2 || isNil(selectedConditionId),
      },
    },
    [SkipLogicPredefinedControlType.moveDown]: {
      config: {
        handler: () => onConditionMove("down"),
        iconSrc: "png/arrow_down.png",
        description: "move-down-condition",
        disabled: conditions.length < 2 || isNil(selectedConditionId),
      },
    },
    [SkipLogicPredefinedControlType.add]: {
      config: {
        handler: onOpenFoldersSelector,
        iconSrc: "png/add14.png",
        description: "add-condition",
      },
    },
    [SkipLogicPredefinedControlType.removeAll]: {
      config: {
        handler: onAllConditionsRemove,
        iconSrc: "png/remove_all.png",
        description: "remove-all-conditions",
        disabled: !conditions.length,
      },
    },
  };

  return controls.reduce<Array<SkipLogicInternalControl>>((acc, { type, handler, ...otherProps }) => {
    if (type && predefinedActionsConfig[type]) {
      const action: SkipLogicInternalControl = {
        ...predefinedActionsConfig[type].config,
        ...otherProps,
      };

      acc.push(action);
    }

    return acc;
  }, []);
};
